import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Card from '../components/ui/Card';
import PageHeader from '../components/shared/PageHeader';
import { useAuth } from '../hooks/useAuth';
import { getOfficeContext } from '../lib/office';
import { supabase } from '../lib/supabase';
import { FormOS } from './OrdensServico';

export default function NovaOS() {
  const navigate = useNavigate();
  const { perfil } = useAuth();
  const [loading, setLoading] = useState(true);
  const [context, setContext] = useState({
    officeId: null,
    mechanics: [],
  });

  useEffect(() => {
    async function load() {
      try {
        const { officeId } = await getOfficeContext();
        if (!officeId) throw new Error('Oficina não identificada.');

        const mechanics = await supabase
          .from('usuarios')
          .select('id,nome')
          .eq('oficina_id', officeId)
          .eq('ativo', true)
          .order('nome');

        if (mechanics.error) throw mechanics.error;

        setContext({
          officeId,
          mechanics: mechanics.data || [],
        });
      } catch (error) {
        toast.error(error.message || 'Não foi possível preparar a nova OS.');
      } finally {
        setLoading(false);
      }
    }

    load();
  }, []);

  if (loading) {
    return <div className="flex h-64 items-center justify-center text-zinc-400">Preparando nova OS...</div>;
  }

  return (
    <div className="space-y-4">
      <PageHeader title="Nova Ordem de Serviço" subtitle="Cadastro guiado com numeração e estoque transacionais" />
      <Card>
        <FormOS
          mecanicos={context.mechanics}
          officeId={context.officeId}
          canViewFinance={perfil?.perfil === 'admin'}
          onCancel={() => navigate('/ordens-servico')}
          onCreated={() => navigate('/ordens-servico')}
        />
      </Card>
    </div>
  );
}
